<ion-content class="triangle-background">
  <div class="container flex flex-col items-center mt-10">
    <div class="flex flex-col justify-center items-center bg-white rounded-full bg-opacity-80 w-64 h-64">
      <ion-icon class="wallet-icon" name="wallet-outline"></ion-icon>
    </div>
    <div class="flex flex-col items-center gap-4 w-full">
      @if (loading) {
        <div class="text-center w-full px-4">
          <ion-skeleton-text animated class="h-12 w-full rounded mb-4"></ion-skeleton-text>
          <ion-skeleton-text animated class="h-12 w-full rounded mb-2"></ion-skeleton-text>
        </div>
      } @else {
        <div class="text-center text-destacadoM">
          {{ 'CHECKOUT.PAYMENT_TYPE.TITLE' | transloco: { total: pendingAmount ? pendingAmount : '' } }}
        </div>
        <gt-button expand="max" (click)="doPayment()">
          <ion-icon class="text-2xl" name="card-outline"></ion-icon>
          {{ 'CHECKOUT.PAYMENT_TYPE.CARD' | transloco }}</gt-button
        >
        <gt-button expand="max" [routerLink]="['/payment', 'transfer', inscriptionId]"
          ><ion-icon class="text-2xl" name="gt-bank"></ion-icon>
          {{ 'CHECKOUT.PAYMENT_TYPE.TRANSFER' | transloco }}</gt-button
        >
      }
      <gt-button expand="max" color="clean" (click)="navController.back()">{{
        'CHECKOUT.PAYMENT_TYPE.BACK' | transloco
      }}</gt-button>
    </div>
  </div>
</ion-content>
